/**
 * Created by tomers on 2/26/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var IntegrationsPropertyModel = require("manager-models/data-sources/integrations/IntegrationsPropertyModel");

    var IntegrationsPropertiesCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        IntegrationsPropertiesCollection = Backbone.Collection.extend({
            model : IntegrationsPropertyModel,

            getNumberOfEditableProperties: function() {
                return this.where({"isEditable":true}).length;
            },
            areModelsValid: function() {
                var result = true;
                _.each(this.models, function(model, index){
                    if (model.isEditable()) {
                        result = model.isValidAttr() && result;
                    }
                });
                return result;
            },
            search: function(query, multiple) {
                var model;
                var result = [];
                var pattern = new RegExp($.trim(query).replace(/ /gi, '|' ), "i");
                for (var i = 0; i < this.models.length; i++) {
                    model = this.models[i];

                    for (var attr in model.attributes) {
                        if (model.attributes.hasOwnProperty(attr) && pattern.test(model.attributes[attr])){
                            if (multiple) {
                                result.push(model);
                            }
                            else {
                                return model;
                            }
                        }
                    }
                }

                return result;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsPropertiesCollection;
});
